import { type ZodTypeAny, z } from "zod";
import type InputType from "../../Input/InputType";
import { JsonInputType } from "../../Input/JsonInputType";
import { SideName } from "../../Side/SideName";
import Plate from "../Plate";

export default class Egg extends Plate {
	public static code = "plate_egg";

	public calculateSideLength(side: SideName, input: InputType) {
		const length = Number(input[JsonInputType.Length]);
		const width = Number(input[JsonInputType.Width]);

		if (!(Number.isNaN(length) || Number.isNaN(width))) {
			switch (side) {
				case SideName.Length1: {
					const lr = width / 2;
					const sr = lr / 2;
					const d = length - (lr + sr);
					const f = lr - sr;
					const jr = (d ** 2 + lr ** 2 - sr ** 2) / (2 * f);
					const ja = Math.atan(d / ((f ** 2 - d ** 2) / (2 * f)));

					return lr * Math.PI + jr * ja * 2 + (Math.PI / 2 - ja) * sr;
				}
			}
		}

		return undefined;
	}

	protected getDimensionSchema(): ZodTypeAny {
		const inputs = super.getDimensionSchema();

		return inputs.superRefine((data, context) => {
			if (data.width > data.length) {
				context.addIssue({
					code: z.ZodIssueCode.too_small,
					type: "number",
					minimum: data.width,
					inclusive: false,
					path: ["length"],
				});
			}
		});
	}
}
